const NAMESPACE = "frontpage"
const NEWS_NAMESPACE = "news"

export { NAMESPACE, NEWS_NAMESPACE }
